/**
 * Payment Verification Reducer for Story 3: Independent Payment Verification
 */

const initialState = {
  pendingVerifications: [],
  reconciliationReport: null,
  mismatchAlerts: [],
  auditTrail: [],
  loading: false,
  error: null,
  userRole: null,
  canAccess: null, // null = belum diketahui, true = bisa akses, false = tidak bisa
};

const paymentVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PENDING_VERIFICATIONS": {
      return {
        ...state,
        pendingVerifications: action.payload,
        loading: false,
        error: null,
      };
    }
    case "SET_VERIFICATION_LOADING": {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case "SET_VERIFICATION_ERROR": {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    case "VERIFY_PAYMENT_SUCCESS": {
      return {
        ...state,
        pendingVerifications: state.pendingVerifications.filter(
          (v) => v.id !== action.payload.verification_id
        ),
        loading: false,
      };
    }
    case "REJECT_PAYMENT_SUCCESS": {
      return {
        ...state,
        pendingVerifications: state.pendingVerifications.filter(
          (v) => v.id !== action.payload.verification_id
        ),
        loading: false,
      };
    }
    case "UPLOAD_PAYMENT_PROOF_SUCCESS": {
      return {
        ...state,
        loading: false,
      };
    }
    case "SET_RECONCILIATION_REPORT": {
      return {
        ...state,
        reconciliationReport: action.payload,
        loading: false,
        error: null,
      };
    }
    case "SET_MISMATCH_ALERTS": {
      return {
        ...state,
        mismatchAlerts: action.payload,
        loading: false,
        error: null,
      };
    }
    case "SET_AUDIT_TRAIL": {
      return {
        ...state,
        auditTrail: action.payload,
        loading: false,
        error: null,
      };
    }
    case "SET_KASIR_USER_INFO": {
      return {
        ...state,
        userRole: action.payload.role || null,
        canAccess: action.payload.can_access ?? null,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default paymentVerificationReducer;
